import React, { lazy, Suspense } from 'react';

const WebformHousingPriceCalculator = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import('./index.lazy')), 1000);
  });
});

const WebformHousingPriceCalculatorSuspense = (props) => (
  <Suspense>
    <WebformHousingPriceCalculator {...props} />
  </Suspense>
);

export default WebformHousingPriceCalculatorSuspense;
